import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { compose } from 'redux'
import { history } from 'store/configureStore'
import * as ROUTES from '../../constants/routes'
import { getCurrentSession } from '../../services/authService'
import { saveOnLocalStorage, localStorageKeys } from '../../services/localstorage'
import Loading from '../../components/Loading'

class JoinTeamPreamble extends Component {
  async componentDidMount() {
    const { location } = this.props
    const query = new URLSearchParams(location.search)
    let teamId
    let teamName
    for (const param of query.entries()) {
      const [variable, value] = param
      if (variable === 'teamId') {
        teamId = value
      } else if (variable === 'teamName') {
        teamName = value
      }
    }

    if (!teamId) {
      history.replace(ROUTES.CHECK_AUTH)
      return
    }

    saveOnLocalStorage(localStorageKeys.JOIN_TEAM_ID, teamId)
    saveOnLocalStorage(localStorageKeys.JOIN_TEAM_NAME, teamName)

    const session = await getCurrentSession()
    if (session) {
      history.replace(ROUTES.JOIN_TEAM)
    }
  }

  render() {
    return (
      <>
        <Loading />
      </>
    )
  }
}

const HOC = compose(withRouter)

export default HOC(JoinTeamPreamble)
